import {
  Box,
  Button,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AutofocusTextFields from "./autoFocusedTextField";
import { useSelector } from "react-redux";
import { ModalHeader } from "../../common/modalHeader";
import CloseIcon from "@mui/icons-material/Close";

const data = {
  name: "",
  loginId: "",
  passcode: "",
  myBusinessId: 0,
  status: "",
  buyerGroupIdList: [],
};

export default function AddAssociatedUser({
  selectedUser,
  open,
  setOpen,
  addUser,
  setSelectedUser,
  updateUser,
}) {
  const [itemData, setItemData] = useState(data);
  const onClose = () => {
    setItemData(data);
    setOpen(false);
  };
  useEffect(() => {
    if (open === false) {
      setItemData(data);
      setSelectedUser();
    }
  }, [open]);
  useEffect(() => {
    if (selectedUser) {
      setItemData({
        ...selectedUser,
        buyerGroupIdList: [],
      });
    }
  }, [selectedUser]);
  const { userDetail } = useSelector((state) => state.reducer);
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { borderRadius: "0" },
      }}
      fullWidth={true}
      maxWidth="xs"
      onClose={onClose}
    >
      {/* <ModalHeader
        title="Associate Users"
        titleStyles={{ fontSize: "17px", fontWeight: 500 }}
        onClose={() => setOpen(false)}
      /> */}
      {/* <DialogTitle color="primary">Associate Users</DialogTitle>
       */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
          backgroundColor: "#CECEFF",
          boxShadow: 3,
        }}
      >
        <Typography
          color="#000"
          fontWeight={500}
          fontSize={{ fontSize: { xs: "13px", sm: "14px", md: "17px" } }}
        >
          Associate Users
        </Typography>
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon sx={{ color: "#000" }} />
        </IconButton>
      </Box>
      <Divider />
      <DialogContent sx={{ px: { xs: 1, sm: 3 }, pt: "0px", pb: "4px" }}>
        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            sx={{
              "& .MuiInputBase-input": {
                color: "#000", // inner text
                fontWeight: 500,
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#01008BA8", // Normal state
                  borderWidth: "2px",
                },
                "&:hover fieldset": {
                  borderColor: "#01008BA8", // Hover state
                },
                "Enter M-Pin&.Mui-focused fieldset": {
                  borderColor: "#01008BA8", // Focused state
                },
              },
            }}
            InputProps={{
              sx: {
                background: "#fff",
                borderRadius: 1,
                cursor: "pointer",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
            }}
            value={itemData.name}
            onInput={(e) =>
              (e.target.value = e.target.value.replace(/^\w/, (c) =>
                c.toUpperCase()
              ))
            }
            onChange={(e) => {
              setItemData({ ...itemData, name: e.target.value });
            }}
            label="Name"
            InputLabelProps={{
              className: "mulish",

              sx: {
                color: "#01008B",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
            }}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            value={itemData.loginId}
            onChange={(e) => {
              setItemData({ ...itemData, loginId: e.target.value });
            }}
            sx={{
              "& .MuiInputBase-input": {
                color: "#000",
                fontWeight: 500,
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#01008BA8", // Normal state
                  borderWidth: "2px",
                },
                "&:hover fieldset": {
                  borderColor: "#01008BA8", // Hover state
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#01008BA8", // Focused state
                },
              },
            }}
            InputProps={{
              sx: {
                background: "#fff",
                borderRadius: 1,
                cursor: "pointer",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
            }}
            label="User Id"
            InputLabelProps={{
              className: "mulish",

              sx: {
                color: "#01008B",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
            }}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              m: 0,
              fontWeight: 500,
              color: "#01008B",
            }}
          >
            Enter M-Pin
          </Typography>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <AutofocusTextFields
              itemData={itemData}
              setItemData={setItemData}
            />
          </Box>
        </Box>
        {/* {selectedUser && ( */}
        <FormGroup>
          <FormControlLabel
            sx={{
              justifyContent: "space-between",
              m: 0,
              flexDirection: "row-reverse",
              "& .MuiFormControlLabel-label": {
                color: "#01008B",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              },
            }}
            control={
              <Switch
                checked={itemData.status === "active"}
                onChange={(e) => {
                  setItemData({
                    ...itemData,
                    status: e.target.checked ? "active" : "inactive",
                  });
                }}
              />
            }
            label="Status"
          />
        </FormGroup>
        {/* )} */}
      </DialogContent>
      <Divider
        sx={{
          borderBottomWidth: "2px",
          borderColor: "#01008B",
          mx: 3,
        }}
      />
      <DialogActions
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Button
          disabled={
            itemData?.name?.trim().length === 0 ||
            itemData?.loginId?.trim()?.length <= 4 ||
            itemData?.passcode?.length !== 4
          }
          sx={{ px: 12, fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
          variant="contained"
          onClick={() => {
            // setOpen(false);

            if (selectedUser) {
              updateUser(itemData?.guId, {
                ...itemData,
                myBusinessId: userDetail?.myBusinessId,
              });
            } else {
              addUser({ ...itemData, myBusinessId: userDetail?.myBusinessId });
            }
            setOpen(false);
            // setItemData(data);
          }}
        >
          {selectedUser ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
